import React, { ComponentProps, FC } from 'react';
import { Button } from './styles';

type Props = ComponentProps<typeof Button> & {
  title?: string;
  ariaLabel?: string;
  isFromMvpApp?: boolean;
};

export const PortalButton: FC<Props> = ({
  title,
  ariaLabel,
  children,
  colorType = 'primary',
  ref,
  isFromMvpApp,
  ...buttonsProps
}) => {
  return (
    <Button
      isFromMvpApp={isFromMvpApp}
      aria-label={ariaLabel}
      colorType={colorType}
      {...buttonsProps}
    >
      {title || children || null}
    </Button>
  );
};
